/**
 * Compatibility shim — re-exports useAuth() bridging new-arch providers.
 *
 * The dev-branch settings components (AdminTab, AgentConfigEditor,
 * AgentPromptEditor, OwnersTab) were restored as stand-ins while the
 * rewrite container layer is built out. They import useAuth() from here.
 * This shim delegates to useCapabilities() + useAgentCatalog() so they
 * continue to work without modification.
 *
 * Remove this file once those components are replaced by rewrite containers
 * that consume the new providers directly.
 */

import { useCapabilities, type Capabilities } from '../app/providers/CapabilitiesProvider';
import { useAgentCatalog } from '../app/providers/AgentCatalogProvider';
import type { AgentView } from '@/entities/agent';

export type { Capabilities };

export interface AuthContextValue {
  capabilities: Capabilities | null;
  loading: boolean;
  agents: readonly AgentView[];
  agentsLoading: boolean;
  agentsError: string | null;
}

export function useAuth(): AuthContextValue {
  const { capabilities, loading } = useCapabilities();
  const { agents, agentsLoading, agentsError } = useAgentCatalog();
  return {
    capabilities,
    loading,
    agents,
    agentsLoading,
    agentsError: agentsError?.message ?? null,
  };
}
